import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GridService } from '../shared/grid/grid.service';
import { JobDictionary } from '../models/jobDictionary.model';
import { JobDictionaryRecordHistory } from '../models/jobDictionaryRecordHistory.model';

@Injectable({
  providedIn: 'root'
})
export class JobDictionaryService extends GridService<JobDictionary> {

  constructor(http: HttpClient) {
    super('JobDictionary', http);
  }

  getHistory(params: HttpParams): Observable<{ data: JobDictionaryRecordHistory[] }> {
    return this.http.get<{ data: JobDictionaryRecordHistory[] }>(
      this.getApiUrl(`${this.controllerName}/GetHistory`),
      { params }
    );
  }
}
